import React from "react"
import { sortRowStyle } from "./styles"
import { SortOption } from "./hooks/useExplodedViewParts"

type SortControlProps = {
	value: SortOption
	onChange: (value: SortOption) => void
}

export const SortControl: React.FC<SortControlProps> = ({ value, onChange }) => (
	<div css={sortRowStyle}>
		<div className="sort-select-wrapper">
			<select value={value} onChange={(e) => onChange(e.target.value as SortOption)}>
				<option value="part_index_asc">Bill of Materials (Low to High)</option>
				<option value="part_index_desc">Bill of Materials (High to Low)</option>
				<option value="part_name_asc">Name A-Z</option>
				<option value="part_name_desc">Name Z-A</option>
			</select>
			<span className="sort-icon">
				<svg
					width="12"
					height="14"
					viewBox="0 0 12 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path d="M6 1L10.5 6H1.5L6 1Z" fill="#374151" />
					<path d="M6 13L1.5 8H10.5L6 13Z" fill="#374151" />
				</svg>
			</span>
		</div>
	</div>
)
